import { jsx as _jsx } from "react/jsx-runtime";
/* Implements transient props from styled-components v5.1+
 * https://styled-components.com/docs/api#transient-props
 *
 * The TypeScript type doesn't filter out $-prefixed props automatically because
 * template literal types aren't yet available to us.  Specify these props under
 * TransientProps instead, for example:
 * withTransientStyleProps<UIButtonProps, { $myProps: number }>(UIButton)
 */
export function withTransientStyleProps(WrappedComponent) {
  return function (props) {
    const nonTransientProps = Object.fromEntries(Object.entries(props).filter(([key]) => !key.startsWith('$')));
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, nonTransientProps));
  };
}